import { render, staticRenderFns } from "./AdminClientUser.vue?vue&type=template&id=d33a2188&scoped=true&"
import script from "./AdminClientUser.vue?vue&type=script&lang=js&"
export * from "./AdminClientUser.vue?vue&type=script&lang=js&"
import style0 from "./AdminClientUser.vue?vue&type=style&index=0&id=d33a2188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33a2188",
  null
  
)

export default component.exports